// extracted by mini-css-extract-plugin
export default {"project__container":"Projects_project__container__ZAY2d","project__card":"Projects_project__card__K2MjR","colored":"Projects_colored__+jA6m"};